import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { getStorage, type FirebaseStorage } from 'firebase/storage';

// Public Firebase web config — safe to expose (not a secret). Override with .env for another project.
export const FIREBASE_CONFIG = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? 'AIzaSyCdfZArg4CQK5tDIdpO1XUu87S5SAgA91I',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'ostx-asma.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'ostx-asma',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? 'ostx-asma.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '86691830692',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '1:86691830692:web:7df0f7f5277e977db8ff31'
};

const app: FirebaseApp = getApps()[0] ?? initializeApp(FIREBASE_CONFIG);

export const auth: Auth = getAuth(app);
export const db: Firestore = getFirestore(app);
export const storage: FirebaseStorage = getStorage(app);

export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
